<template>
  <main-layout>
    <v-container>
      <v-layout class="mt-5 mb-3">
        <v-flex shrink>
          <toggle-button
            :value="selectedBot.maintenance"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </v-flex>

        <v-flex>
          <h1 class="title my-0 pl-2">บอทตอบเวลาปรับปรุงระบบ</h1>
        </v-flex>
      </v-layout>
      <template v-if="loading"> </template>
      <template v-else>
        <intent-item
          :livechat="false"
          :key="'intent'"
          v-model="intent"
          :excludedIntentName="''"
          :hideDelete="true"
          :hideCopy="true"
          :hideQuestion="true"
          :readonlyName="true"
          :hideSetting="true"
          :hidePriority="true"
          :hideAdvanceOptions="[
            'context',
            'line_notify',
            'limit_reply_to_inbox',
            'intent_group',
            'follow_up'
          ]"
          :hideChoice="true"
          :availableBubbles="['text', 'button', 'image']"
          :hideStatus="true"
        />
      </template>
    </v-container>
  </main-layout>
</template>

<script>
import trueidApi from '@/api/trueid'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import intentItem from '@/components/view/intent/intent-item'
import cloneDeep from 'lodash/cloneDeep'
export default {
  data() {
    return {
      intent: {},
      loading: true
    }
  },
  components: {
    intentItem,
    ToggleButton
  },
  async mounted() {
    let tempIntent = {
      ...cloneDeep(this.intentTemplate()),
      intentname: '{maintenance_message}'
    }
    const intent = await this.getSystemMaintenanceConversation()
    if (intent) tempIntent = intent

    this.intent = tempIntent
    this.intent.isShow = true
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    })
  },
  methods: {
    async getSystemMaintenanceConversation() {
      try {
        const response = await trueidApi.getSystemMaintenanceConversation({
          config: {
            params: {
              page_id: this.selectedBot.pageid
            }
          }
        })
        return response.data.data || undefined
      } catch (error) {
        console.error(error)
        return undefined
      }
    },
    async onChangeStatus(val) {
      const result = await this.$swal.fire({
        title:
          'หลังจากกดปิดการใช้งาน หากทำการเปิดใหม่ ผู้ใช้งานจะได้รับข้อความแจ้งเตือนใหม่อีกครั้ง',
        type: 'warning',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel')
      })

      if (result.value) {
        try {
          const response = await trueidApi.postSystemMaintenanceConversation({
            config: {},
            data: {
              page_id: this.selectedBot.pageid,
              status: val.value
            }
          })

          if (response) {
            const botlistIndex = this.botlist.findIndex(
              (bot) => bot.pageid === this.selectedBot.pageid
            )
            this.botlist[botlistIndex].maintenance = val.value
            this.$store.dispatch('selectBot', this.botlist[botlistIndex])
            this.$store.dispatch('updateBotlist', this.botlist)
          }
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/trueid/SystemMaintenance.vue